import { isString } from 'lodash';
import { makeApi, makeBenefitsApi } from 'src/http/api/internal/internal-http';
import { OnboardingRepository } from 'src/repositories/personalization/onboarding/onboarding.repository';
import { OnboardingItemType } from 'src/types/onboarding';
import { toBase64 } from 'src/utils/utils';
import { create } from 'zustand';

type States = {
  isLoadingOnboarding: boolean;
  isLoadingUpdateOnboarding: boolean;
  onboarding: OnboardingItemType | null;
};

type Actions = {
  getOnboardingDetails: () => Promise<void>;
  updateOnboarding: (updatedOnboarding: any) => Promise<void>;
};

type Onboarding = Actions & States;

const initialValues = {
  isLoadingOnboarding: false,
  isLoadingUpdateOnboarding: false,
  onboarding: null,
};

const onboardingRepository = new OnboardingRepository(makeBenefitsApi());
const authRepository = new OnboardingRepository(makeApi());

export const useOnboardingStore = create<Onboarding>((set: any, get: any) => ({
  ...initialValues,

  getOnboardingDetails: async () => {
    set({ isLoadingOnboarding: true });
    const response = await onboardingRepository.getOnboardingDetails();

    if (response.isLeft()) {
      set({ isLoadingOnboarding: false });
      throw new Error(response.value.message);
    } else {
      set({ onboarding: response.value, isLoadingOnboarding: false });
    }
  },

  updateOnboarding: async (updatedOnboarding) => {
    set({ isLoadingUpdateOnboarding: true });

    if (!isString(updatedOnboarding.startImage)) {
      const imgBase64: any = await toBase64(updatedOnboarding.startImage);
      const res: any = await authRepository.uploadFile({
        name: updatedOnboarding.startImage.name,
        base64: imgBase64,
      });
      updatedOnboarding.startImage = res.value.data.url;
    }

    updatedOnboarding.onboardingSteps = await Promise.all(
      updatedOnboarding.onboardingSteps.map(async (step: any) => {
        if (!isString(step.stepImage)) {
          const stepImgBase64: any = await toBase64(step.stepImage);
          const stepRes: any = await authRepository.uploadFile({
            name: step.stepImage.name,
            base64: stepImgBase64,
          });
          return {
            ...step,
            stepImage: stepRes.value.data.url, 
          };
        }
        return step; 
      })
    );

    const response = await onboardingRepository.updateOnboarding(updatedOnboarding);

    if (response.isLeft()) {
      set({ isLoadingUpdateOnboarding: false });
      throw new Error(response.value.message);
    } else {
      set({ isLoadingUpdateOnboarding: false });
    }
  },
}));
